module.exports = __webpack_public_path__ + "img/bifold-vertical.676aa855.svg";